import {
  Button,
  Dialog,
  DialogContent,
  Typography,
} from '@growdash/design-system/atoms';
import { GROWINTEL_PATHS } from '@growdash/growintel/constants/GrowintelPaths';
import { useOnboarding } from '@growdash/growintel/hooks/useOnboarding';
import { useRouter } from '@growdash/growintel/hooks/useRouter';
import useTabState from '@growdash/growintel/hooks/useTabState';

export default function WatchlistOnboardingDialog() {
  const { updateTabState: updateSearchPageState } = useTabState('search');
  const router = useRouter();
  const { isOnboarded, markAsOnboarded } = useOnboarding('watchlist');

  if (isOnboarded) return null;

  return (
    <Dialog
      defaultOpen
      onOpenChange={(open) => {
        if (!open) {
          markAsOnboarded();
        }
      }}
    >
      <DialogContent className="min-w-fit text-center">
        <Typography className="font-bold text-2xl">
          Track the competition that matters.
        </Typography>
        <Typography className="text-sm mt-6">
          Add restaurants to see how they perform across price, delivery, rating
          and more, all in one smart view.
        </Typography>
        <Typography className="text-sm mt-2 font-bold">
          Everything you need to stay one step ahead - all in one place.
        </Typography>
        <div className="mt-10">
          <Button
            onClick={() => {
              updateSearchPageState({ selectedSubTab: 'brand' });
              router.replace(GROWINTEL_PATHS.SEARCH);
              markAsOnboarded();
            }}
          >
            Build Watchlist
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
